"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndex = void 0;
var _get = _interopRequireDefault(require("es-toolkit/compat/get"));
var _getSlidesPerViewWithBreakpoints = require("./getSlidesPerViewWithBreakpoints");
var _isSlidesLoopEnabled = require("./isSlidesLoopEnabled");
const getIndex = ({
  instanceRef,
  isAtTheEnd,
  isAtTheStart,
  setIsAtTheEnd,
  setIsAtTheStart,
  slider,
  slidesCount,
  viewportWidth,
  type,
  useBreakpointsPerView
}) => {
  const currentSlide = (0, _get.default)(instanceRef, 'current.track.details.rel', 0);
  const slidesLoopEnabled = (0, _isSlidesLoopEnabled.isSlidesLoopEnabled)(slider);
  const slidesPerView = Math.floor((0, _getSlidesPerViewWithBreakpoints.getSlidesPerViewWithBreakpoints)({
    slider,
    viewportWidth,
    useBreakpointsPerView
  }));
  if (type === 'next') {
    if (Boolean(slidesLoopEnabled) && isAtTheEnd) {
      setIsAtTheEnd(false);
      setIsAtTheStart(true);
      return 0;
    }
    if (currentSlide + slidesPerView >= slidesCount - slidesPerView) {
      setIsAtTheEnd(true);
      setIsAtTheStart(false);
      return slidesCount - slidesPerView;
    }
    setIsAtTheEnd(false);
    setIsAtTheStart(false);
    return currentSlide + slidesPerView;
  }
  if (slidesLoopEnabled && isAtTheStart) {
    setIsAtTheEnd(true);
    setIsAtTheStart(false);
    return slidesCount - slidesPerView;
  }
  if (currentSlide - slidesPerView <= 0) {
    setIsAtTheEnd(false);
    setIsAtTheStart(true);
    return 0;
  }
  setIsAtTheEnd(false);
  setIsAtTheStart(false);
  return currentSlide - slidesPerView;
};
exports.getIndex = getIndex;
